"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgTemplate = function SvgTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h32v32H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.002 1v1.999h-2V5h2v28h-24s-2 0-2-2V4.018L1.001 4c-.035-1.355.807-2.314 1.555-2.646.738-.362 1.362-.35 1.446-.354h23M3.998 5h19.004V2.999h-19c-.002.006-.032-.002-.149.019-.115.019-.274.06-.404.125-.253.171-.414.21-.447.857.015.5.134.609.272.743.144.126.401.212.579.239A.871.871 0 0 0 3.998 5m1.004 26h20V7h-20v24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 23v-2h12v2H7zm0-8v-2h16v2H7zm0 4v-2h16v2H7z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgTemplate);
var _default = exports["default"] = Memo;